import React from 'react';
import { useCustomerType } from '../context/CustomerTypeContext';

interface PriceWithVatLabelProps {
  price: number;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
  suffix?: string;
}

const PriceWithVatLabel: React.FC<PriceWithVatLabelProps> = ({
  price,
  className = '',
  valueClassName = '',
  labelClassName = '',
  suffix = ''
}) => {
  const { vatLabel } = useCustomerType();

  return (
    <div className={className}>
      <div className={valueClassName}>
        {price} kr{suffix}
      </div>
      <div className={labelClassName}>{vatLabel}</div>
    </div>
  );
};

export default PriceWithVatLabel;

